import React, { forwardRef, HTMLProps } from 'react';

import Link, { LinkProps } from 'next/link';
import { useParams } from 'next/navigation';

const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps & HTMLProps<HTMLAnchorElement>>(
  ({ children, href, ...rest }, ref) => {
    const { lang } = useParams<{ lang: string }>();
    let localizedPath = href;
    if (lang !== 'en' && !href.startsWith('http')) localizedPath = `/${lang}${href}`;

    return (
      <Link href={localizedPath.toLowerCase()} {...rest} ref={ref}>
        {children}
      </Link>
    );
  }
);

LocalizedLink.displayName = 'LocalizedLink';

export default LocalizedLink;
